/**
 * CartaoAtendimento — o atalho "Fale com o Atendimento" do Início (PR 5).
 *
 * O Augusto pediu este atalho ACIMA dos comunicados: depois da saudação, é a
 * ação mais óbvia da página. Por isso é o único bloco sólido em verde numa
 * página clara — o olho vai nele primeiro.
 *
 * É um `<Link>` do React Router (marcação, não lógica de navegação): quem
 * decide o destino é a página, via `href`. Alvo de toque de 72 px de altura
 * mínima, bem acima dos 48 px exigidos, porque o parceiro usa o portal no
 * celular. Gradiente a partir do emerald-700: branco sobre emerald-600 não
 * passa no contraste AA para texto pequeno (3,6:1); sobre emerald-700 passa (5,5:1).
 *
 * P1 (revisão de design) — `rounded-lg`, não `rounded-xl`: neste projeto
 * `rounded-lg` é `var(--radius)` = 14 px (cartões, painel, avisos, caixa do
 * vídeo) e `rounded-xl` são 12 px fixos — o bloco de destaque era o MENOS
 * arredondado da página.
 */
import { ArrowRight, MessagesSquare } from "lucide-react";
import { Link } from "react-router-dom";

export interface CartaoAtendimentoProps {
  href: string;
}

export function CartaoAtendimento({ href }: CartaoAtendimentoProps) {
  return (
    <Link
      to={href}
      data-testid="inicio-atendimento"
      className="group flex min-h-[4.5rem] items-center gap-4 rounded-lg bg-gradient-to-br from-emerald-700 to-teal-800 px-4 py-4 text-white shadow-md ring-1 ring-emerald-900/10 transition-all hover:-translate-y-0.5 hover:shadow-lg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-emerald-500 focus-visible:ring-offset-2 sm:px-6"
    >
      <span
        aria-hidden="true"
        className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-white/15 ring-1 ring-white/25"
      >
        <MessagesSquare className="h-6 w-6" />
      </span>
      <span className="min-w-0 flex-1">
        <span className="block text-base font-semibold leading-snug sm:text-lg">
          Fale com o Atendimento
        </span>
        <span className="block text-sm text-emerald-100">
          Abra uma conversa com a nossa equipe.
        </span>
      </span>
      <ArrowRight
        aria-hidden="true"
        className="h-6 w-6 shrink-0 transition-transform group-hover:translate-x-1"
      />
    </Link>
  );
}

export default CartaoAtendimento;
